import { library } from '@fortawesome/fontawesome-svg-core';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import {
  faChevronCircleDown,
  faChevronCircleRight,
  faCircle,
  faTrashAlt,
  faEdit,
  faQuestionCircle,
  faInfoCircle,
  faExternalLinkSquareAlt,
  faMinusCircle,
  faPlusCircle,
  faCaretUp,
  faCaretDown,
  faColumns,
  faFileDownload,
  faSave,
  faUndo,
  faAngleDown,
  faAngleUp,
  faTimesCircle,
  faFilter,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faTwitter,
  faFacebook,
  faInstagram,
  faYoutube,
  faChevronCircleDown,
  faChevronCircleRight,
  faCircle,
  faTrashAlt,
  faEdit,
  faQuestionCircle,
  faInfoCircle,
  faExternalLinkSquareAlt,
  faMinusCircle,
  faPlusCircle,
  faCaretUp,
  faCaretDown,
  faColumns,
  faFileDownload,
  faSave,
  faUndo,
  faAngleDown,
  faAngleUp,
  faTimesCircle,
  faFilter,
);
